/*
** Disqus-related Dynamic Code
** by Nate Beversluis, 2020
**
** Based on a miminal example at
** https://help.disqus.com/en/articles/1717163-using-disqus-on-ajax-sites
*/

import { loadScript } from './utils';

var resetDisqus = function (newIdentifier, newUrl, newTitle) {
   
    if (window.DISQUS) {
        loadDisqusComments(newIdentifier, newUrl, newTitle);
    } else {
         loadScript('https://wfmt-blogs.disqus.com/embed.js', () => {
             loadDisqusComments(newIdentifier, newUrl, newTitle);
         });
    }
 }
 
 function loadDisqusComments(newIdentifier, newUrl, newTitle)  {
     
    DISQUS.reset({
        reload: true,
        config: function () {
            this.page.identifier = newIdentifier;
            this.page.url = newUrl;
        }
    });

}

 export { resetDisqus }